/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLicenseUsageEntity
 */
export interface UserLicenseUsageEntity {
    /**
     * 有効（ENABLED）ユーザー数
     * @type {number}
     * @memberof UserLicenseUsageEntity
     */
    enabledUserCount: number;
    /**
     * ライセンス（プラン）で許容される最大ユーザー数
     * @type {number}
     * @memberof UserLicenseUsageEntity
     */
    maxUsers: number;
}

/**
 * Check if a given object implements the UserLicenseUsageEntity interface.
 */
export function instanceOfUserLicenseUsageEntity(value: object): value is UserLicenseUsageEntity {
    if (!('enabledUserCount' in value) || value['enabledUserCount'] === undefined) return false;
    if (!('maxUsers' in value) || value['maxUsers'] === undefined) return false;
    return true;
}

export function UserLicenseUsageEntityFromJSON(json: any): UserLicenseUsageEntity {
    return UserLicenseUsageEntityFromJSONTyped(json, false);
}

export function UserLicenseUsageEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLicenseUsageEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'enabledUserCount': json['enabledUserCount'],
        'maxUsers': json['maxUsers'],
    };
}

export function UserLicenseUsageEntityToJSON(json: any): UserLicenseUsageEntity {
    return UserLicenseUsageEntityToJSONTyped(json, false);
}

export function UserLicenseUsageEntityToJSONTyped(value?: UserLicenseUsageEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabledUserCount': value['enabledUserCount'],
        'maxUsers': value['maxUsers'],
    };
}

